module.exports = __webpack_public_path__ + "img/code.adb3d28e.jpg";